import * as Yup from 'yup'

export const containerDateFormValidation = Yup.object().shape({
    activityDate: Yup.string()
        .required('Date is required')
})